module.exports = __webpack_public_path__ + "resources/image_loading_hor.2289400ac6554890.png";